import { Col, Row, DatePicker, Form, Modal, Checkbox } from "antd";
import React, {useEffect} from "react";
import {downloadFile} from "../../helpers/download-file";
import moment from "moment/moment";

export const ExportModal = ({ visible, onClose }) => {

    const [form] = Form.useForm();

    const handleOk = () => {
        form.submit();
    }

    const handleSubmit = async (values) => {
        await downloadFile(`/api/v1/booking/export`, `Buchungen_${moment().format('YYYYMMDD_HHmm')}.csv`, { startDate: moment(values.startDate).format("YYYY-MM-DD"), endDate:  moment(values.endDate).format("YYYY-MM-DD"), includeCancelled: !!values.includeCancelled });
    }

    useEffect(() => {
        if(!visible) {
            form.resetFields();
        }
    }, [visible]);

    return (
        <Modal
            maskClosable={false}
            destroyOnClose={true}
            visible={visible}
            title="Buchungen exportieren"
            onCancel={onClose}
            onOk={handleOk}
            width={"800px"}
            okText="Exportieren"
            cancelText="Schließen"
        >
            <Form
                form={form}
                onFinish={handleSubmit}
                layout={"vertical"}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label={"Startdatum"}
                            name={"startDate"}
                            required
                            rules={[{ required: true, message: 'Startdatum ist erforderlich' }]}
                        >
                            <DatePicker style={{width: '100%'}} format={"DD.MM.YYYY"} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label={"Enddatum"}
                            name={"endDate"}
                            required
                            rules={[{ required: true, message: 'Enddatum ist erforderlich' }]}
                        >
                            <DatePicker style={{width: '100%'}} format={"DD.MM.YYYY"} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name={"includeCancelled"}
                            valuePropName="checked"
                        >
                            <Checkbox>Stornierte Buchungen einbeziehen</Checkbox>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}